// @ts-strict-ignore
import styled, { css } from "styled-components";

export const AccordionContent = styled.div`
  margin: 0px 0px 40px;
  width: 100%;
`;

export const AccordionBox = styled.div`
  margin: 0px 0px;
  width: 100%;
  border-bottom: 1px solid ${({ theme }) => theme.colorPalette.gray[100]};
  .accBody {
    height: 0px;
    opacity: 0;
    padding: 0px 40px 0px 0px;
    transition: 0.2s all ease-in-out;
    overflow: hidden;
  }
  & > div:first-child {
    img {
      transform: rotate(0deg);
      transition: 0.2s all ease-in-out;
    }
  }
  ${(props) =>
    props?.isCollapsed &&
    css`
      .accBody {
        height: auto;
        padding: 0px 40px 16px 0px;
        transition: 0.2s all ease-in-out;
        opacity: 1;
      }
      & > div:first-child {
        img {
          transform: rotate(180deg);
          transition: 0.2s all ease-in-out;
        }
      }
    `};
`;

export const AccordionHeader = styled.div`
  padding: 16px 0px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
`;
export const AccordionBody = styled.div`
  width: 100%;
  p {
    a {
      color: ${({ theme }) => theme.colorPalette.black};
    }
  }
`;
